import { create, type StateCreator } from "zustand";
import { persist } from "zustand/middleware";

import type { BrandingConfig } from "@utilifeed/config/branding";
import { zustandMiddlware } from "@utilifeed/core/stores/middleware";
import type { PropAIOrganization } from "@core/apis/PropAI/types";

type State = {
  selectedOrganization: PropAIOrganization | null;
  /** Branding fetched from the dedicated branding endpoint, separate from the organization. */
  branding: BrandingConfig | null;
};

type Actions = {
  setOrganization: (organization: PropAIOrganization | null) => void;
  setBranding: (branding: BrandingConfig | null) => void;
};

export type PropAIOrganizationStore = State & Actions;

const storeCreator: StateCreator<
  PropAIOrganizationStore,
  [["zustand/devtools", never]],
  [],
  PropAIOrganizationStore
> = (set) => ({
  selectedOrganization: null,
  branding: null,
  setOrganization: (selectedOrganization) => set({ selectedOrganization }),
  setBranding: (branding) => set({ branding }),
});

export const organizationStore = create<PropAIOrganizationStore>()(
  persist(zustandMiddlware(storeCreator, { name: "PropAIOrganizationStore" }), {
    name: "propai-organization-store",
    partialize: (state) => ({ branding: state.branding }),
  })
);

export default organizationStore;
